import { Record } from 'immutable';
import BaseStore from './BaseStore';
import { ActionTypes } from '../constants/AppConstants';

const FamilyVerificationState = new Record({
    isVerified: false,
    token: null,
    email: null,
    availableTickets: null,
    isLoading: false,
    error: null,
    allowanceExceeded: false,
});

export class FamilyVerificationStore extends BaseStore {
    getInitialState() {
        return new FamilyVerificationState();
    }

    getActionHandlers() {
        return {
            [ActionTypes.FAMILY_VERIFICATION_STARTED]: this.handleVerificationStarted,
            [ActionTypes.FAMILY_VERIFICATION_VERIFIED]: this.handleSetVerified,
            [ActionTypes.FAMILY_VERIFICATION_FAILED]: this.handleVerificationFailed,
            [ActionTypes.FAMILY_VERIFICATION_RESET]: this.handleResetVerification,
            [ActionTypes.FAMILY_VERIFICATION_ALLOWANCE_EXCEEDED]: this.handleAllowanceExceeded,
        };
    }

    handleVerificationStarted() {
        this.setState(this.state.merge({ isLoading: true, error: null, allowanceExceeded: false }));
    }

    handleSetVerified({ token, email, availableTickets }) {
        this.setState(
            this.state.merge({
                isVerified: true,
                token,
                email,
                availableTickets,
                isLoading: false,
                error: null,
                allowanceExceeded: false,
            }),
        );
    }

    handleVerificationFailed({ error }) {
        this.setState(
            this.state.merge({
                isLoading: false,
                error,
                isVerified: false,
            }),
        );
    }

    handleResetVerification() {
        this.setState(this.getInitialState());
    }

    handleAllowanceExceeded() {
        this.setState(
            this.state.merge({
                allowanceExceeded: true,
            }),
        );
    }

    isVerified() {
        return this.get('isVerified');
    }

    getToken() {
        return this.get('token');
    }

    getEmail() {
        return this.get('email');
    }

    getAvailableTickets() {
        return this.get('availableTickets');
    }

    isLoading() {
        return this.get('isLoading');
    }

    getError() {
        return this.get('error');
    }

    isAllowanceExceeded() {
        return this.get('allowanceExceeded');
    }

    getVerifiedEmail() {
        return this.isVerified() ? this.getEmail() : null;
    }
}

const instance = new FamilyVerificationStore({
    storageKey: 'familyVerification',
    expires: 24 * 60 * 60, // 24 hours in seconds
});

export default instance;



// WEBPACK FOOTER //
// ./src/stores/FamilyVerificationStore.js